import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyapphomebodyadmin} from './/bodyapphomebodyadmin'
import { Footerappprivateadmin } from './/footerappprivateadmin'
import withRouter from './/withRouter'
class Bodyappadmin extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
    if(window.localStorage.getItem('MY_APP_STATE_AUTHCODE') == ''){
       window.location = ('/')
    }
  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyapphomebodyadmin/>
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappadmin);